<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${importation.name}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="importation" />
  </div>
</template>

<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";
export default {
  name: "import-view-logs",

  components: { LogListTable },

  props: ["importation"],

  watch: {
    user(user) {},
  },
};
</script>
